<template>
  <div class="router-content">
    <div class="content-header">
      <span class="content-header-span fl">模版名称：</span>
      <el-input size="mini" placeholder="请填写模版名称搜索" class="search-text fl"></el-input>
      <el-tooltip class="item" effect="dark" content="添加模版" placement="top">
        <el-button size="mini" @click="insetrTemplate" class="search-button fr" type="primary" icon="el-icon-plus"></el-button>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="搜索模版" placement="top">
        <el-button size="mini" @click="searchTemplate" class="search-button fr" type="primary" icon="el-icon-search"></el-button>
      </el-tooltip>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      templates: [
        {}
      ]
    }
  },
  methods: {
    insetrTemplate () { },
    searchTemplate () { }
  }
}
</script>

<style scoped>
@import "../../../css/etms/home.css";
@import "../../../css/iconfont.css";
</style>



// WEBPACK FOOTER //
// src/components/etms/ctms/my_template.vue